/**
 * Deprecated no-op DotTip component.
 *
 * @return {null} Nothing.
 */
export function DotTip() {
	return null;
}

export default DotTip;
